import { useEffect, useRef } from 'react'

const scriptId = 'frill-script'

export const useLoadFrillWidgetScript = onLoaded => {
  const loadHandlerRef = useRef()
  useEffect(
    () => {
      const existing = document.getElementById(scriptId)
      if (existing) {
        return
      }
      const scriptTag = document.createElement('script')
      scriptTag.src = 'https://widget.frill.co/v2/widget.js'
      scriptTag.id = scriptId
      scriptTag.async = 'async'
      document.body.appendChild(scriptTag)
    },
    [onLoaded]
  )

  useEffect(
    () => {
      if (!loadHandlerRef.current && onLoaded) {
        loadHandlerRef.current = true
        if (window.Frill) {
          onLoaded()
        } else {
          document.getElementById(scriptId).addEventListener('load', onLoaded)
        }
      }
      return () => {
        if (loadHandlerRef.current && onLoaded) {
          loadHandlerRef.current = false
          document
            .getElementById(scriptId)
            .removeEventListener('load', onLoaded)
        }
      }
    },
    [onLoaded]
  )
}
